import { checkHasRole } from '@core/utils/roleAccess';

export const hasRole = {
  bind(el, binding) {
    const requiredRole = binding.value;

    if (!checkHasRole(requiredRole)) {
      if (el.parentNode) {
        el.parentNode.removeChild(el);
      } else {
        el.style.display = 'none';
      }
    }
  }
};

export default hasRole;
